import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-siaceb',
  templateUrl: './siaceb.component.html',
  styleUrls: ['./siaceb.component.css']
})
export class SiacebComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
